<template>
  <div>
    <div v-if="calculatesAsa" class="alert alert-info">
      Bitte warte kurz bis die Berechnung fertig ist bevor du eine Stufe
      aktivieren/deaktivieren kannst!
    </div>
    <div class="alert alert-info">
      <p>
        Eine Asa ist ein Wiederanschreiben eines Mitglieds, nach dem dieses
        Mitglied bereits in einem Dialog geschrieben hat, aber nicht mehr
        antwortet. Sprich, die Moderation hat die letzte Nachricht geschrieben.
      </p>
      <p>
        Eine Asa Stufe entspricht einer Nachricht. Das heißt, Wenn im System
        eine ASA Stufe eingetragen ist, wird das Mitglied nach der letzten
        Nachricht eines Moderators ein weiteres Mal angeschrieben. Bei 10 ASA
        Stufen wird das Mitglied 10 Mal erneut angeschrieben.
      </p>
    </div>
    <v-table
      url="/api/v1/asa"
      :attributes="[
        {
          attribute: 'duration_formatted',
          name: 'Dauer'
        },
        {
          attribute: 'update_page_url',
          name: 'Bearbeiten',
          type: 'ActionCell',
          label: 'Bearbeiten'
        },
        {
          attribute: 'update_url',
          name: 'Löschen',
          type: 'DeleteCell',
          label: 'Löschen'
        },
        {
          attribute: 'active',
          name: 'Aktiv?',
          type: 'ToggleCell',
          url: 'toggle_active_url',
          disabled: this.calculatesAsa
        }
      ]"
    ></v-table>
  </div>
</template>

<script lang="babel">
import { bus } from "@/bus";

export default {
  data() {
    return {
      state: 0
    };
  },
  created() {
    bus.$on("background-task-update", data => {
      if (data.name === "calculate-asa") {
        this.state = 2;
      } else if (this.state === 2) {
        this.state = 0;
      }
    });
    bus.$on("asa-active-switched", () => {
      this.state = 1;
    });
  },
  computed: {
    calculatesAsa() {
      return this.$store.getters["backgroundTask/running"]('calculate-asa') || (this.state > 0);
    }
  }
}
</script>
